import { useMemo, useState } from 'react';

type CategoryOption = {
  id: string;
  nome: string;
  cor?: string | null;
  funnelId?: string | null;
  funnel?: { id?: string; nome?: string; cor?: string | null } | null;
};

export function ContactCategorySelector({ categories, value, onChange, label = 'Categoria para salvar o contato', optional = true }: { categories: CategoryOption[]; value: string; onChange: (id: string) => void; label?: string; optional?: boolean }) {
  const [search, setSearch] = useState('');
  const groups = useMemo(() => {
    const term = search.trim().toLowerCase();
    const filtered = categories.filter((item) => `${item.nome} ${item.funnel?.nome || ''}`.toLowerCase().includes(term));
    const map = new Map<string, { id: string; name: string; color: string; items: CategoryOption[] }>();
    for (const item of filtered) {
      const id = item.funnelId || item.funnel?.id || 'none';
      if (!map.has(id)) map.set(id, { id, name: item.funnel?.nome || 'Sem funil', color: item.funnel?.cor || '#94a3b8', items: [] });
      map.get(id)!.items.push(item);
    }
    return Array.from(map.values()).sort((a, b) => a.id === 'none' ? 1 : b.id === 'none' ? -1 : a.name.localeCompare(b.name, 'pt-BR'));
  }, [categories, search]);
  const selected = categories.find((item) => item.id === value);

  return <div>
    <label className="mb-1.5 block text-sm font-medium text-gray-700">{label}</label>
    {selected && <div className="mb-2 flex items-center gap-2 rounded-lg border border-blue-200 bg-blue-50 px-3 py-2 text-sm text-blue-800"><span className="h-2.5 w-2.5 rounded-full" style={{ backgroundColor: selected.cor || selected.funnel?.cor || '#2563eb' }} /><span className="font-medium">{selected.nome}</span>{selected.funnel?.nome && <span className="text-xs text-blue-500">— {selected.funnel.nome}</span>}</div>}
    <div className="overflow-hidden rounded-lg border border-gray-300 bg-gray-50">
      <div className="border-b border-gray-200 bg-white p-2">
        <input value={search} onChange={(e) => setSearch(e.target.value)} placeholder="Buscar categoria ou funil..." className="w-full rounded-md border border-gray-300 px-3 py-2 text-sm focus:outline-none focus:ring-2 focus:ring-blue-500" />
      </div>
      <div className="max-h-56 overflow-y-auto p-2">
        <button type="button" onClick={() => onChange('')} className={`mb-2 w-full rounded-md px-3 py-2 text-left text-sm ${!value ? 'bg-blue-100 font-medium text-blue-700' : 'text-gray-600 hover:bg-white'}`}>{optional ? 'Sem categoria' : 'Selecione uma categoria'}</button>
        {groups.map((group) => <div key={group.id} className="mb-2 last:mb-0">
          <div className="flex items-center gap-2 px-2 py-1 text-xs font-semibold uppercase tracking-wide text-gray-500"><span className="h-2.5 w-2.5 rounded-full" style={{ backgroundColor: group.color }} />{group.name}</div>
          {group.items.map((item) => <button key={item.id} type="button" onClick={() => onChange(item.id)} className={`ml-3 flex w-[calc(100%-0.75rem)] items-center gap-2 rounded-md px-3 py-2 text-left text-sm ${value === item.id ? 'bg-blue-100 font-medium text-blue-700' : 'text-gray-700 hover:bg-white'}`}><span className="h-2.5 w-2.5 rounded-full" style={{ backgroundColor: item.cor || group.color }} /><span className="truncate">{item.nome}</span></button>)}
        </div>)}
        {groups.length === 0 && <p className="p-3 text-center text-sm text-gray-500">Nenhuma categoria encontrada.</p>}
      </div>
    </div>
  </div>;
}
